import { useMutation, useQueryClient } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"

import { useToast } from "src/hooks/use_toast"
import { useTracker } from "src/hooks/use_tracker"

const useWorkOrderActionMutation = ({
  workOrderSequentialId,
  action,
  eventPrefix,
  successMessage,
  errorMessage,
  onClose,
}) => {
  const { marinaSlug } = useMarina()
  const showToast = useToast()
  const queryClient = useQueryClient()
  const tracker = useTracker()

  const { mutate, isLoading } = useMutation(
    () => action(marinaSlug, workOrderSequentialId),
    {
      onSuccess: () => {
        tracker.trackEvent(`${eventPrefix}:confirmed`, {
          workOrderSequentialId,
        })
        queryClient.invalidateQueries([
          "workOrder",
          marinaSlug,
          workOrderSequentialId,
        ])
        queryClient.invalidateQueries(["workOrders", marinaSlug])
        showToast(successMessage, { type: "success" })
        onClose()
      },
      onError: (error) => {
        tracker.trackEvent(`${eventPrefix}:save_failed`, {
          workOrderSequentialId,
          reason: error?.message,
        })
        showToast(error.message || errorMessage, { type: "error" })
      },
    }
  )

  const handleCancel = () => {
    tracker.trackEvent(`${eventPrefix}:discarded`, { workOrderSequentialId })
    onClose()
  }

  return { mutate, isLoading, handleCancel }
}

export default useWorkOrderActionMutation
